const accordions = document.querySelectorAll('.product-description__accordion, .accordion-grid__item, .image-text-block__accordion');

if(accordions){
    accordions.forEach(accordion => {
        const accordHeader = accordion.querySelector('.product-description__accordion__header, .accordion-grid__title, .image-text-block__accordion__header');
        accordHeader.addEventListener('click', () => {
            accordion.classList.toggle('active');
            const panel = accordion.querySelector('.product-description__accordion__content, .accordion-grid__content, .image-text-block__accordion__content');
            if(panel.style.height){
                panel.style.height = null;
            } else {
                panel.style.height = panel.scrollHeight + 'px';
            }
        });
    });
}